import React from 'react'
import { Box } from '@mui/material'
import { PrepareStage } from './PrepareStage'
import { ProcessStage } from './ProcessStage'
import { ApplyStage } from './ApplyStage'
import { PipelineStatus } from './PipelineStatus'
import { SetupPipeline } from './SetupPipeline'
import type { AITreeToolProps } from './types'

export function AITreeTool({ treeId, versionId }: AITreeToolProps) {
  return (
    <Box>
      <PipelineStatus treeId={treeId} versionId={versionId} />
      <SetupPipeline />
      <PrepareStage treeId={treeId} versionId={versionId} />
      <ProcessStage treeId={treeId} versionId={versionId} />
      <ApplyStage treeId={treeId} versionId={versionId} />
    </Box>
  )
}
